import styled from "styled-components";

import { Headline } from "./typography";

export const ContactHeadline = styled(Headline)`
	margin: 0 0 30px;
`;
